import { render, staticRenderFns } from "./EtaxDetail.vue?vue&type=template&id=47f0baa1&scoped=true"
import script from "./EtaxDetail.vue?vue&type=script&lang=js"
export * from "./EtaxDetail.vue?vue&type=script&lang=js"
import style0 from "./EtaxDetail.vue?vue&type=style&index=0&id=47f0baa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0baa1",
  null
  
)

export default component.exports